import { render } from "./QiweiQrcode.vue?vue&type=template&id=3552a45e&scoped=true"
import script from "./QiweiQrcode.vue?vue&type=script&lang=js"
export * from "./QiweiQrcode.vue?vue&type=script&lang=js"

import "./QiweiQrcode.vue?vue&type=style&index=0&id=3552a45e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3552a45e"]])

export default __exports__